import { render } from "./ChanceQuoteDetail.vue?vue&type=template&id=0e8a8066&scoped=true"
import script from "./ChanceQuoteDetail.vue?vue&type=script&lang=js"
export * from "./ChanceQuoteDetail.vue?vue&type=script&lang=js"

import "./ChanceQuoteDetail.vue?vue&type=style&index=0&id=0e8a8066&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e8a8066"]])

export default __exports__